import { render, staticRenderFns } from "./addUserContact.vue?vue&type=template&id=0f3d28e7"
import script from "./addUserContact.vue?vue&type=script&lang=js"
export * from "./addUserContact.vue?vue&type=script&lang=js"
import style0 from "./addUserContact.vue?vue&type=style&index=0&id=0f3d28e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports